(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enquiry-basket"] && !Shopify.designMode) return;
  try {
    
/* Ensure enquiry basket runtime is bundled with this section */
(function () {
  'use strict';
  if (window.EnquiryBasketUI && window.EnquiryBasketUI.__booted) return;

  var STORAGE_KEY = 'yorklon_enquiry_basket';
  var EVENT_NAME = 'enquiry-basket:update';
  var memoryItems = null;

  function readItems() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var data = JSON.parse(raw);
      return Array.isArray(data.items) ? data.items : [];
    } catch (error) {
      return memoryItems ? memoryItems.slice() : [];
    }
  }

  function writeItems(items) {
    memoryItems = items;
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ items: items }));
    } catch (error) {}
  }

  function getItems() {
    if (memoryItems) return memoryItems.slice();
    var items = readItems();
    memoryItems = items;
    return items.slice();
  }

  function setItems(items) {
    var next = Array.isArray(items) ? items : [];
    writeItems(next);
    document.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { items: next, count: next.length } }));
  }

  function makeId(productId, variantId) {
    return String(productId) + ':' + (variantId || 'default');
  }

  function has(id) {
    return getItems().some(function (item) { return String(item.id) === String(id); });
  }

  function add(item) {
    var items = getItems();
    var id = String(item.id || makeId(item.productId, item.variantId));
    if (items.some(function (entry) { return String(entry.id) === id; })) {
      return { items: items, added: false, removed: false };
    }
    var nextItem = {
      id: id,
      productId: item.productId || '',
      productTitle: item.productTitle || '',
      productHandle: item.productHandle || '',
      productUrl: item.productUrl || '',
      variantId: item.variantId || '',
      variantTitle: item.variantTitle || '',
      colour: item.colour || item.variantTitle || '',
      image: item.image || '',
      addedAt: Date.now(),
    };
    items.push(nextItem);
    setItems(items);
    return { items: items, added: true, removed: false, item: nextItem };
  }

  function remove(id) {
    var items = getItems().filter(function (item) { return String(item.id) !== String(id); });
    setItems(items);
    return { items: items, added: false, removed: true };
  }

  function toggle(item) {
    var id = String(item.id || makeId(item.productId, item.variantId));
    if (has(id)) {
      var result = remove(id);
      result.item = Object.assign({}, item, { id: id });
      return result;
    }
    return add(Object.assign({}, item, { id: id }));
  }

  function clear() { setItems([]); }

  function formatSummary(items) {
    items = items || getItems();
    if (!items.length) return 'No products selected.';
    return items.map(function (item, index) {
      var colour = item.colour || item.variantTitle || 'Default';
      var line = index + 1 + ') ' + (item.productTitle || 'Product') + ' — ' + colour;
      if (item.variantId) line += '\n   Variant ID: ' + item.variantId;
      if (item.productUrl) line += '\n   ' + item.productUrl;
      return line;
    }).join('\n\n');
  }

  window.EnquiryBasket = {
    getItems: getItems,
    setItems: setItems,
    getCount: function () { return getItems().length; },
    has: has,
    makeId: makeId,
    add: add,
    remove: remove,
    toggle: toggle,
    clear: clear,
    formatSummary: formatSummary,
  };

  function updateBadges(count) {
    if (typeof count !== 'number') count = getItems().length;
    document.querySelectorAll('[data-enquiry-count]').forEach(function (el) {
      el.textContent = count > 99 ? '99+' : String(count);
      el.hidden = count < 1;
      el.setAttribute('aria-hidden', count < 1 ? 'true' : 'false');
    });
    document.querySelectorAll('[data-enquiry-open]').forEach(function (el) {
      el.disabled = count < 1;
      el.setAttribute('aria-disabled', count < 1 ? 'true' : 'false');
    });
  }

  function syncButtons() {
    document.querySelectorAll('[data-enquiry-toggle]').forEach(function (button) {
      var id = button.getAttribute('data-enquiry-id');
      if (!id) return;
      var inBasket = has(id);
      button.classList.toggle('is-in-basket', inBasket);
      button.setAttribute('aria-pressed', inBasket ? 'true' : 'false');
    });
  }

  function showToast(message) {
    var toast = document.querySelector('[data-enquiry-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'enquiry-toast';
      toast.setAttribute('data-enquiry-toast', '');
      toast.setAttribute('role', 'status');
      toast.innerHTML = '<span class="enquiry-toast__text"></span>';
      document.body.appendChild(toast);
    }
    var text = toast.querySelector('.enquiry-toast__text');
    if (text) text.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(showToast._timer);
    showToast._timer = setTimeout(function () { toast.classList.remove('is-visible'); }, 2800);
  }

  function handleToggle(button) {
    if (!button) return false;
    var now = Date.now();
    var last = Number(button.getAttribute('data-enquiry-last-toggle') || 0);
    if (now - last < 350) return false;
    button.setAttribute('data-enquiry-last-toggle', String(now));
    var item = {
      id: button.getAttribute('data-enquiry-id'),
      productId: button.getAttribute('data-product-id'),
      productTitle: button.getAttribute('data-product-title'),
      productHandle: button.getAttribute('data-product-handle'),
      productUrl: button.getAttribute('data-product-url'),
      variantId: button.getAttribute('data-variant-id'),
      variantTitle: button.getAttribute('data-variant-title'),
      colour: button.getAttribute('data-colour'),
      image: button.getAttribute('data-image'),
    };
    if (!item.id) item.id = makeId(item.productId, item.variantId);
    var result = toggle(item);
    syncButtons();
    updateBadges();
    var name = (item.productTitle || 'Item') + (item.colour ? ' — ' + item.colour : '');
    if (result.added) showToast(name + ' added to enquiry basket');
    else if (result.removed) showToast(name + ' removed from enquiry basket');
    return true;
  }

  window.EnquiryBasketUI = {
    __booted: true,
    onToggle: function (event, button) {
      if (event) {
        if (event.preventDefault) event.preventDefault();
        if (event.stopPropagation) event.stopPropagation();
      }
      handleToggle(button || (event && event.currentTarget));
      return false;
    },
    toggle: handleToggle,
    showToast: showToast,
    sync: function () { updateBadges(); syncButtons(); },
  };

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (target && target.nodeType === 3) target = target.parentElement;
    if (!target || !target.closest) return;
    var button = target.closest('[data-enquiry-toggle]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    handleToggle(button);
  }, true);

  document.addEventListener(EVENT_NAME, function (event) {
    updateBadges(event.detail && typeof event.detail.count === 'number' ? event.detail.count : getItems().length);
    syncButtons();
  });

  function init() {
    updateBadges();
    syncButtons();
    if (document.querySelector('[data-enquiry-success]')) {
      clear();
      updateBadges(0);
      syncButtons();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
		constructor() {
			super()
		}

		connectedCallback() {
			this.header = document.querySelector('.shopify-section-header')
			this.headerWrapper = document.querySelector('.header-wrapper')
			this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always'
			this.headerBounds = {}
			this.currentScrollTop = 0
			this.preventReveal = false
			this.predictiveSearch = this.querySelector('predictive-search')

			this.onScrollHandler = this.onScroll.bind(this)
			this.hideHeaderOnScrollUp = () => (this.preventReveal = true)

			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
			window.addEventListener('scroll', this.onScrollHandler, false)

			this.createObserver()
		}

		disconnectedCallback() {
			this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
			window.removeEventListener('scroll', this.onScrollHandler)
		}

		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
				this.headerBounds = entries[0].intersectionRect
				observer.disconnect()
			})

			if (this.header) {
				observer.observe(this.header)
			}
		}

		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop

			if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
				this.header.classList.add(
					'shopify-section-header-sticky',
					'shopify-section-header-always-sticky',
				)
				this.header.classList.remove('color-background-3')
				this.header.style.transition =
					'background var(--duration-short), transform var(--duration-default)'
			}

			if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
				this.header.classList.remove('shopify-section-header-sticky')
				this.header.style.transition = 'background var(--duration-short)'
				if (this.header.classList.contains('color-background-1')) {
					this.header.classList.add('color-background-3')
				}
			}

			if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				if (this.preventHide) return
				requestAnimationFrame(this.hide.bind(this))
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				if (!this.preventReveal) {
					requestAnimationFrame(this.reveal.bind(this))
				} else {
					window.clearTimeout(this.isScrolling)

					this.isScrolling = setTimeout(() => {
						this.preventReveal = false
					}, 66)

					requestAnimationFrame(this.hide.bind(this))
				}
			} else if (scrollTop <= this.headerBounds.top) {
				requestAnimationFrame(this.reset.bind(this))
			}

			this.currentScrollTop = scrollTop
		}

		hide() {
			if (this.headerIsAlwaysSticky) return
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky')
			this.closeMenuDisclosure()
		}

		reveal() {
			if (this.headerIsAlwaysSticky) return
			this.header.classList.add('shopify-section-header-sticky', 'animate')
			this.header.classList.remove('shopify-section-header-hidden', 'color-background-3')
		}

		reset() {
			if (this.headerIsAlwaysSticky) return
			this.header.classList.remove(
				'shopify-section-header-hidden',
				'shopify-section-header-sticky',
				'animate',
			)
			if (this.header.classList.contains('color-background-1')) {
				this.header.classList.add('color-background-3')
			}
		}

		closeMenuDisclosure() {
			this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure')
			if (this.disclosures) {
				this.disclosures.forEach((disclosure) => {
					disclosure.close()
				})
			}
			this.disclosureLists = this.header.querySelectorAll('.disclosure__list')
			if (this.disclosureLists) {
				this.disclosureLists.forEach((disclosureList) => {
					disclosureList.setAttribute('hidden', true)
				})
			}
		}
	}

	customElements.define('sticky-header', StickyHeader)

	/* Enquiry basket runtime — loaded on every page via header */
	;(function () {
		'use strict'
		if (window.EnquiryBasketUI && window.EnquiryBasketUI.__booted) return

		var STORAGE_KEY = 'yorklon_enquiry_basket'
		var EVENT_NAME = 'enquiry-basket:update'
		var memoryItems = null

		function readItems() {
			try {
				var raw = window.localStorage.getItem(STORAGE_KEY)
				if (!raw) return []
				var data = JSON.parse(raw)
				return Array.isArray(data.items) ? data.items : []
			} catch (error) {
				return memoryItems ? memoryItems.slice() : []
			}
		}

		function writeItems(items) {
			memoryItems = items
			try {
				window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ items: items }))
			} catch (error) {}
		}

		function getItems() {
			if (memoryItems) return memoryItems.slice()
			var items = readItems()
			memoryItems = items
			return items.slice()
		}

		function setItems(items) {
			var next = Array.isArray(items) ? items : []
			writeItems(next)
			document.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { items: next, count: next.length } }))
		}

		function makeId(productId, variantId) {
			return String(productId) + ':' + (variantId || 'default')
		}

		function has(id) {
			return getItems().some(function (item) {
				return String(item.id) === String(id)
			})
		}

		function add(item) {
			var items = getItems()
			var id = String(item.id || makeId(item.productId, item.variantId))
			if (
				items.some(function (entry) {
					return String(entry.id) === id
				})
			) {
				return { items: items, added: false, removed: false }
			}
			var nextItem = {
				id: id,
				productId: item.productId || '',
				productTitle: item.productTitle || '',
				productHandle: item.productHandle || '',
				productUrl: item.productUrl || '',
				variantId: item.variantId || '',
				variantTitle: item.variantTitle || '',
				colour: item.colour || item.variantTitle || '',
				image: item.image || '',
				addedAt: Date.now(),
			}
			items.push(nextItem)
			setItems(items)
			return { items: items, added: true, removed: false, item: nextItem }
		}

		function remove(id) {
			var items = getItems().filter(function (item) {
				return String(item.id) !== String(id)
			})
			setItems(items)
			return { items: items, added: false, removed: true }
		}

		function toggle(item) {
			var id = String(item.id || makeId(item.productId, item.variantId))
			if (has(id)) {
				var result = remove(id)
				result.item = Object.assign({}, item, { id: id })
				return result
			}
			return add(Object.assign({}, item, { id: id }))
		}

		function clear() {
			setItems([])
		}

		function formatSummary(items) {
			items = items || getItems()
			if (!items.length) return 'No products selected.'
			return items
				.map(function (item, index) {
					var colour = item.colour || item.variantTitle || 'Default'
					var line = index + 1 + ') ' + (item.productTitle || 'Product') + ' — ' + colour
					if (item.variantId) line += '\n   Variant ID: ' + item.variantId
					if (item.productUrl) line += '\n   ' + item.productUrl
					return line
				})
				.join('\n\n')
		}

		window.EnquiryBasket = {
			getItems: getItems,
			setItems: setItems,
			getCount: function () {
				return getItems().length
			},
			has: has,
			makeId: makeId,
			add: add,
			remove: remove,
			toggle: toggle,
			clear: clear,
			formatSummary: formatSummary,
		}

		function updateBadges(count) {
			if (typeof count !== 'number') count = getItems().length
			document.querySelectorAll('[data-enquiry-count]').forEach(function (el) {
				el.textContent = count > 99 ? '99+' : String(count)
				el.hidden = count < 1
				el.setAttribute('aria-hidden', count < 1 ? 'true' : 'false')
			})
			document.querySelectorAll('[data-enquiry-open]').forEach(function (el) {
				el.disabled = count < 1
				el.setAttribute('aria-disabled', count < 1 ? 'true' : 'false')
			})
		}

		function syncButtons() {
			document.querySelectorAll('[data-enquiry-toggle]').forEach(function (button) {
				var id = button.getAttribute('data-enquiry-id')
				if (!id) return
				var inBasket = has(id)
				button.classList.toggle('is-in-basket', inBasket)
				button.setAttribute('aria-pressed', inBasket ? 'true' : 'false')
			})
		}

		function showToast(message) {
			var toast = document.querySelector('[data-enquiry-toast]')
			if (!toast) {
				toast = document.createElement('div')
				toast.className = 'enquiry-toast'
				toast.setAttribute('data-enquiry-toast', '')
				toast.setAttribute('role', 'status')
				toast.innerHTML = '<span class="enquiry-toast__text"></span>'
				document.body.appendChild(toast)
			}
			var text = toast.querySelector('.enquiry-toast__text')
			if (text) text.textContent = message
			toast.classList.add('is-visible')
			clearTimeout(showToast._timer)
			showToast._timer = setTimeout(function () {
				toast.classList.remove('is-visible')
			}, 2800)
		}

		function handleToggle(button) {
			if (!button) return false
			var now = Date.now()
			var last = Number(button.getAttribute('data-enquiry-last-toggle') || 0)
			if (now - last < 350) return false
			button.setAttribute('data-enquiry-last-toggle', String(now))
			var item = {
				id: button.getAttribute('data-enquiry-id'),
				productId: button.getAttribute('data-product-id'),
				productTitle: button.getAttribute('data-product-title'),
				productHandle: button.getAttribute('data-product-handle'),
				productUrl: button.getAttribute('data-product-url'),
				variantId: button.getAttribute('data-variant-id'),
				variantTitle: button.getAttribute('data-variant-title'),
				colour: button.getAttribute('data-colour'),
				image: button.getAttribute('data-image'),
			}
			if (!item.id) item.id = makeId(item.productId, item.variantId)
			var result = toggle(item)
			syncButtons()
			updateBadges()
			var name = (item.productTitle || 'Item') + (item.colour ? ' — ' + item.colour : '')
			if (result.added) showToast(name + ' added to enquiry basket')
			else if (result.removed) showToast(name + ' removed from enquiry basket')
			return true
		}

		window.EnquiryBasketUI = {
			__booted: true,
			onToggle: function (event, button) {
				if (event) {
					if (event.preventDefault) event.preventDefault()
					if (event.stopPropagation) event.stopPropagation()
				}
				handleToggle(button || (event && event.currentTarget))
				return false
			},
			toggle: handleToggle,
			showToast: showToast,
			sync: function () {
				updateBadges()
				syncButtons()
			},
		}

		document.addEventListener(
			'click',
			function (event) {
				var target = event.target
				if (target && target.nodeType === 3) target = target.parentElement
				if (!target || !target.closest) return
				var button = target.closest('[data-enquiry-toggle]')
				if (!button) return
				event.preventDefault()
				event.stopPropagation()
				handleToggle(button)
			},
			true,
		)

		document.addEventListener(EVENT_NAME, function (event) {
			updateBadges(
				event.detail && typeof event.detail.count === 'number'
					? event.detail.count
					: getItems().length,
			)
			syncButtons()
		})

		function init() {
			updateBadges()
			syncButtons()
			if (document.querySelector('[data-enquiry-success]')) {
				clear()
				updateBadges(0)
				syncButtons()
			}
		}

		if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init)
		else init()
	})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);

		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

customElements.define('product-modal', ProductModal);

/* Enquiry basket — bundled with this section so it cannot 404 as a missing asset */
(function () {
  'use strict';

  if (window.EnquiryBasketUI && window.EnquiryBasketUI.__booted) return;

  var STORAGE_KEY = 'yorklon_enquiry_basket';
  var EVENT_NAME = 'enquiry-basket:update';
  var memoryItems = null;

  function readItems() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var data = JSON.parse(raw);
      return Array.isArray(data.items) ? data.items : [];
    } catch (error) {
      console.warn('EnquiryBasket read failed', error);
      return memoryItems ? memoryItems.slice() : [];
    }
  }

  function writeItems(items) {
    memoryItems = items;
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ items: items }));
    } catch (error) {
      console.warn('EnquiryBasket write failed — using memory', error);
    }
  }

  function getItems() {
    if (memoryItems) return memoryItems.slice();
    var items = readItems();
    memoryItems = items;
    return items.slice();
  }

  function setItems(items) {
    var next = Array.isArray(items) ? items : [];
    writeItems(next);
    document.dispatchEvent(
      new CustomEvent(EVENT_NAME, {
        detail: { items: next, count: next.length },
      })
    );
  }

  function makeId(productId, variantId) {
    return String(productId) + ':' + (variantId || 'default');
  }

  function has(id) {
    return getItems().some(function (item) {
      return String(item.id) === String(id);
    });
  }

  function add(item) {
    var items = getItems();
    var id = String(item.id || makeId(item.productId, item.variantId));
    var existing = null;
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].id) === id) {
        existing = items[i];
        break;
      }
    }
    if (existing) {
      return { items: items, added: false, removed: false, item: existing };
    }
    var nextItem = {
      id: id,
      productId: item.productId || '',
      productTitle: item.productTitle || '',
      productHandle: item.productHandle || '',
      productUrl: item.productUrl || '',
      variantId: item.variantId || '',
      variantTitle: item.variantTitle || '',
      colour: item.colour || item.variantTitle || '',
      image: item.image || '',
      addedAt: Date.now(),
    };
    items.push(nextItem);
    setItems(items);
    return { items: items, added: true, removed: false, item: nextItem };
  }

  function remove(id) {
    var items = getItems().filter(function (item) {
      return String(item.id) !== String(id);
    });
    setItems(items);
    return { items: items, added: false, removed: true };
  }

  function toggle(item) {
    var id = String(item.id || makeId(item.productId, item.variantId));
    if (has(id)) {
      var result = remove(id);
      result.item = Object.assign({}, item, { id: id });
      return result;
    }
    return add(Object.assign({}, item, { id: id }));
  }

  function clear() {
    setItems([]);
  }

  function formatSummary(items) {
    items = items || getItems();
    if (!items.length) return 'No products selected.';
    return items
      .map(function (item, index) {
        var colour = item.colour || item.variantTitle || 'Default';
        var line = index + 1 + ') ' + (item.productTitle || 'Product') + ' — ' + colour;
        if (item.variantId) line += '\n   Variant ID: ' + item.variantId;
        if (item.productUrl) line += '\n   ' + item.productUrl;
        return line;
      })
      .join('\n\n');
  }

  window.EnquiryBasket = {
    getItems: getItems,
    setItems: setItems,
    getCount: function () {
      return getItems().length;
    },
    has: has,
    makeId: makeId,
    add: add,
    remove: remove,
    toggle: toggle,
    clear: clear,
    formatSummary: formatSummary,
  };

  function updateBadges(count) {
    if (typeof count !== 'number') count = getItems().length;

    document.querySelectorAll('[data-enquiry-count]').forEach(function (el) {
      el.textContent = count > 99 ? '99+' : String(count);
      el.hidden = count < 1;
      el.setAttribute('aria-hidden', count < 1 ? 'true' : 'false');
    });

    document.querySelectorAll('[data-enquiry-count-wrap]').forEach(function (el) {
      el.classList.toggle('is-empty', count < 1);
    });

    document.querySelectorAll('[data-enquiry-open]').forEach(function (el) {
      el.disabled = count < 1;
      el.setAttribute('aria-disabled', count < 1 ? 'true' : 'false');
    });
  }

  function syncButtons() {
    document.querySelectorAll('[data-enquiry-toggle]').forEach(function (button) {
      var id = button.getAttribute('data-enquiry-id');
      if (!id) return;
      var inBasket = has(id);
      button.classList.toggle('is-in-basket', inBasket);
      button.setAttribute('aria-pressed', inBasket ? 'true' : 'false');
      var label = button.getAttribute('data-label-add') || 'Add to enquiry basket';
      var labelRemove = button.getAttribute('data-label-remove') || 'Remove from enquiry basket';
      button.setAttribute('aria-label', inBasket ? labelRemove : label);

      var addLabel = button.querySelector('.enquiry-add-label');
      var removeLabel = button.querySelector('.enquiry-remove-label');
      if (addLabel) addLabel.hidden = inBasket;
      if (removeLabel) removeLabel.hidden = !inBasket;
    });
  }

  function showToast(message) {
    var toast = document.querySelector('[data-enquiry-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'enquiry-toast';
      toast.setAttribute('data-enquiry-toast', '');
      toast.setAttribute('role', 'status');
      toast.innerHTML =
        '<span class="enquiry-toast__icon" aria-hidden="true">' +
        '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<circle cx="9" cy="9" r="8" stroke="currentColor" stroke-width="1.4"/>' +
        '<path d="M5.5 9.2L7.8 11.5L12.5 6.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg></span><span class="enquiry-toast__text"></span>';
      document.body.appendChild(toast);
    }

    var text = toast.querySelector('.enquiry-toast__text');
    if (text) text.textContent = message;
    toast.classList.remove('is-visible');
    void toast.offsetWidth;
    toast.classList.add('is-visible');
    clearTimeout(showToast._timer);
    showToast._timer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2800);
  }

  function itemFromButton(button) {
    return {
      id: button.getAttribute('data-enquiry-id'),
      productId: button.getAttribute('data-product-id'),
      productTitle: button.getAttribute('data-product-title'),
      productHandle: button.getAttribute('data-product-handle'),
      productUrl: button.getAttribute('data-product-url'),
      variantId: button.getAttribute('data-variant-id'),
      variantTitle: button.getAttribute('data-variant-title'),
      colour: button.getAttribute('data-colour'),
      image: button.getAttribute('data-image'),
    };
  }

  function handleToggle(button) {
    if (!button) return false;

    var now = Date.now();
    var last = Number(button.getAttribute('data-enquiry-last-toggle') || 0);
    if (now - last < 350) return false;
    button.setAttribute('data-enquiry-last-toggle', String(now));

    var item = itemFromButton(button);
    if (!item.id) {
      item.id = makeId(item.productId, item.variantId);
      button.setAttribute('data-enquiry-id', item.id);
    }
    if (!item.id && !item.productId) {
      console.warn('EnquiryBasket: missing ids on button', button);
      return false;
    }

    try {
      var result = toggle(item);
      syncButtons();
      updateBadges();

      var name = (item.productTitle || 'Item') + (item.colour ? ' — ' + item.colour : '');
      if (result.added) {
        showToast(name + ' added to enquiry basket');
      } else if (result.removed) {
        showToast(name + ' removed from enquiry basket');
      }
      return true;
    } catch (error) {
      console.error('EnquiryBasket toggle failed', error);
      return false;
    }
  }

  function onDocumentClick(event) {
    var target = event.target;
    if (target && target.nodeType === 3) target = target.parentElement;
    if (!target || !target.closest) return;
    var button = target.closest('[data-enquiry-toggle]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    handleToggle(button);
  }

  function init() {
    updateBadges();
    syncButtons();

    if (document.querySelector('[data-enquiry-success]')) {
      clear();
      updateBadges(0);
      syncButtons();
    }
  }

  window.EnquiryBasketUI = {
    __booted: true,
    onToggle: function (event, button) {
      if (event) {
        if (event.preventDefault) event.preventDefault();
        if (event.stopPropagation) event.stopPropagation();
      }
      handleToggle(button || (event && event.currentTarget));
      return false;
    },
    toggle: handleToggle,
    showToast: showToast,
    sync: function () {
      updateBadges();
      syncButtons();
    },
  };

  document.addEventListener('click', onDocumentClick, true);
  document.addEventListener(EVENT_NAME, function (event) {
    updateBadges(event.detail && typeof event.detail.count === 'number' ? event.detail.count : getItems().length);
    syncButtons();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


  } catch(e) { console.error(e); }
})();
})();
